import { createUseStyles } from 'react-jss';
import { xs_only as xsOnly } from 'ctm-css-traits/traits/util/breakpoint_width.css';
import font from 'ctm-css-traits/traits/typography/font.css';

export const useStyles = createUseStyles({
    subtext: ({ vertical }) => ({
        fontWeight: vertical === 'home-contents-insurance' ? font.bold : font.normal,
        marginTop: '1rem'
    }),
    splashWrapper: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        textAlign: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: '3rem'
    },
    splashHeaderWrapper: {
        marginBottom: '2rem'
    },
    splashHeader: {
        margin: '0 auto',
        color: 'var(--brand-primary)',
        fontWeight: '700',
        fontFamily: 'var(--family-heading)',
        fontSize: '2rem',
        lineHeight: '2.4rem'
    },
    splashText: {
        fontWeight: '700',
        fontFamily: 'var(--family-base)',
        marginBottom: '0.5rem'
    },
    quoteButtonWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '430px',
        width: '100%',
        marginBottom: '2rem'
    },
    prefillButtonWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        width: '100%',
        maxWidth: '60rem',
        paddingLeft: '0',
        paddingRight: '0',
        margin: '0',
        '@media (max-device-width: 500px)': {
            flexDirection: 'column-reverse',
            padding: '2.5rem 0',
            gap: '2.5rem'
        },
        '& button': {
            fontSize: '1.6rem'
        }
    },
    linkText: {
        cursor: 'pointer',
        textDecoration: 'underline'
    },
    hero: {
        width: '140px',
        marginBottom: '1.5rem'
    },
    savedText: {
        color: 'var(--brand-base-80)',
        fontSize: '1.2rem',
        fontWeight: '400',
        lineHeight: '1.6rem'
    },
    backButton: {
        position: 'absolute',
        top: '1rem',
        left: '1rem',
        fontSize: '1.6rem',
        '& span': {
            fontSize: '2rem'
        },
        [`@media ${xsOnly}`]: {
            top: '0.5rem',
            left: '0.5rem',
            fontSize: 0,
            '& span': {
                fontSize: '3rem'
            }
        }
    },
    backButtonBottom: {
        position: 'absolute',
        bottom: '5.5rem',
        left: '1rem',
        fontSize: '1.6rem',
        '& span': {
            fontSize: '2rem'
        },
        [`@media ${xsOnly}`]: {
            position: 'unset',
            fontSize: '1.4rem'
        }
    },
    hnc_prefill_verify_wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start',
        paddingBottom: '4rem',
        margin: '0 0.5rem'
    },
    errorWrapper: {
        width: '100%',
        marginTop: '5rem',
        '@media (max-device-width: 500px)': {
            marginTop: '4rem'
        }
    },
    fullscreenLoaderWrapper: {
        display: 'flex',
        position: 'fixed',
        zIndex: '100',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
    }
});
